// 🔥🚀⚡ ULTRA MEGA SUPREME ANIMATED TODO PAGE WITH INFINITE DETAILS 🔥🚀⚡
import React, { useState, useEffect } from 'react';
import { 
    collection, 
    query, 
    onSnapshot, 
    addDoc, 
    updateDoc, 
    deleteDoc, 
    doc,
    orderBy,
    serverTimestamp 
} from 'firebase/firestore';

const TodoPage = ({ user, db, setModalMessage, onBackToPanel }) => {
    // 🔥🚀⚡ ULTRA MEGA SUPREME STATE MANAGEMENT WITH INFINITE NESTING 🔥🚀⚡
    const [todos, setTodos] = useState([]);
    const [filteredTodos, setFilteredTodos] = useState([]);
    const [filter, setFilter] = useState('all');
    const [priority, setPriority] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [showAddForm, setShowAddForm] = useState(false);
    const [newTodo, setNewTodo] = useState('');
    const [newTodoDescription, setNewTodoDescription] = useState('');
    const [newTodoPriority, setNewTodoPriority] = useState('medium');
    const [newTodoCategory, setNewTodoCategory] = useState('feature');
    const [isAdding, setIsAdding] = useState(false);
    const [editingTodo, setEditingTodo] = useState(null);
    const [showStats, setShowStats] = useState(true);
    const [animationTrigger, setAnimationTrigger] = useState(0);
    
    // 🌟💥 ULTRA NESTED SUBTASK SYSTEM 🌟💥
    const [expandedTodos, setExpandedTodos] = useState(new Set());
    const [addingSubtaskTo, setAddingSubtaskTo] = useState(null);
    const [newSubtask, setNewSubtask] = useState('');
    const [newSubtaskDescription, setNewSubtaskDescription] = useState('');
    const [newSubtaskPriority, setNewSubtaskPriority] = useState('medium');
    const [newSubtaskCategory, setNewSubtaskCategory] = useState('feature');
    const [isAddingSubtask, setIsAddingSubtask] = useState(false);
    const [hoveredTodo, setHoveredTodo] = useState(null);
    const [draggedTodo, setDraggedTodo] = useState(null);
    const [ultraAnimations, setUltraAnimations] = useState(true);
    const [explosionEffects, setExplosionEffects] = useState({});
    const [floatingElements, setFloatingElements] = useState([]);
    
    // 🔥⚡💎 ULTRA DETAILED FORM STATES 🔥⚡💎
    const [newTodoComplexity, setNewTodoComplexity] = useState('moderate');
    const [newTodoDepartment, setNewTodoDepartment] = useState('fullstack');
    const [newTodoImpact, setNewTodoImpact] = useState('moderate');
    const [newTodoEffort, setNewTodoEffort] = useState('m');
    const [newTodoType, setNewTodoType] = useState('story');
    const [newTodoSeverity, setNewTodoSeverity] = useState('normal');
    const [newTodoEnvironment, setNewTodoEnvironment] = useState('production');
    const [newTodoEstimatedHours, setNewTodoEstimatedHours] = useState('');
    const [newTodoEstimatedStoryPoints, setNewTodoEstimatedStoryPoints] = useState('');
    const [newTodoTags, setNewTodoTags] = useState('');
    const [newTodoLabels, setNewTodoLabels] = useState('');
    const [newTodoDueDate, setNewTodoDueDate] = useState('');
    const [newTodoStartDate, setNewTodoStartDate] = useState('');
    const [newTodoTargetRelease, setNewTodoTargetRelease] = useState('');
    const [newTodoAssignedTo, setNewTodoAssignedTo] = useState('');
    const [newTodoReporter, setNewTodoReporter] = useState('');
    const [newTodoWatchers, setNewTodoWatchers] = useState('');
    const [newTodoReviewers, setNewTodoReviewers] = useState('');
    const [newTodoQAContact, setNewTodoQAContact] = useState('');
    const [newTodoProductOwner, setNewTodoProductOwner] = useState('');
    const [newTodoDependencies, setNewTodoDependencies] = useState('');
    const [newTodoBlockers, setNewTodoBlockers] = useState('');
    const [newTodoRelatedTasks, setNewTodoRelatedTasks] = useState('');
    const [newTodoComponents, setNewTodoComponents] = useState('');
    const [newTodoAffectedFiles, setNewTodoAffectedFiles] = useState('');
    const [newTodoApiEndpoints, setNewTodoApiEndpoints] = useState('');
    const [newTodoDatabaseChanges, setNewTodoDatabaseChanges] = useState('');
    const [newTodoSecurityConsiderations, setNewTodoSecurityConsiderations] = useState('');
    const [newTodoPerformanceImpact, setNewTodoPerformanceImpact] = useState('');
    const [newTodoMonitoringNeeds, setNewTodoMonitoringNeeds] = useState('');
    const [showAdvancedForm, setShowAdvancedForm] = useState(false);
    
    // 🚀💫 MISSING ULTRA SUPREME STATE VARIABLES 🚀💫
    const [rainbowMode, setRainbowMode] = useState(false);
    const [particleEffects, setParticleEffects] = useState(true); // Always on!
    const [newTodoStoryPoints, setNewTodoStoryPoints] = useState('');
    const [newTodoSprint, setNewTodoSprint] = useState('');
    const [newTodoEpicLink, setNewTodoEpicLink] = useState('');
    const [newTodoTaskType, setNewTodoTaskType] = useState('');
    const [newTodoImpactLevel, setNewTodoImpactLevel] = useState('');
    const [newTodoEffortLevel, setNewTodoEffortLevel] = useState('');
    const [newTodoBusinessValue, setNewTodoBusinessValue] = useState('');
    const [newTodoAcceptanceCriteria, setNewTodoAcceptanceCriteria] = useState('');
    const [newTodoExternalLinks, setNewTodoExternalLinks] = useState('');
    const [newTodoProgress, setNewTodoProgress] = useState(0);
    const [newTodoRiskLevel, setNewTodoRiskLevel] = useState('low');
    const [newTodoSecurityNotes, setNewTodoSecurityNotes] = useState('');
    const [newTodoTestingStrategy, setNewTodoTestingStrategy] = useState('');

    // 🎨🌈🔥 ULTRA MEGA CATEGORIES WITH INFINITE ANIMATIONS 🔥��🎨
    const categories = [
        // { id: 'epic', name: '🏔️👑 Feature', icon: 'fas fa-mountain', color: 'from-purple-600 via-indigo-500 to-purple-700', animation: 'animate-pulse', glow: 'shadow-purple-500/50', description: 'Large feature spanning multiple sprints' },
        { id: 'feature', name: '✨💫 New Feature', icon: 'fas fa-plus-circle', color: 'from-blue-500 via-cyan-400 to-blue-600', animation: 'animate-pulse', glow: 'shadow-blue-500/50', description: 'New functionality or capability' },
        { id: 'enhancement', name: '⚡🚀 Enhancement', icon: 'fas fa-arrow-up', color: 'from-green-500 via-emerald-400 to-green-600', animation: 'animate-pulse', glow: 'shadow-green-500/50', description: 'Improvement to existing feature' },
        { id: 'bug', name: '🐛🔴 Bug Fix', icon: 'fas fa-bug', color: 'from-red-500 via-pink-400 to-red-600', animation: 'animate-pulse', glow: 'shadow-red-500/50', description: 'Fix for broken functionality' },
        { id: 'hotfix', name: '🔥💥 Critical Hotfix', icon: 'fas fa-fire-extinguisher', color: 'from-red-600 via-red-700 to-red-800', animation: 'animate-pulse', glow: 'shadow-red-600/70', description: 'Urgent production fix' },
        { id: 'refactor', name: '🔧⚙️ Code Refactor', icon: 'fas fa-code-branch', color: 'from-orange-500 via-yellow-400 to-yellow-500', animation: 'animate-pulse', glow: 'shadow-orange-500/50', description: 'Code quality improvement' },
        { id: 'tech-debt', name: '⚒️🛠️ Tech Debt', icon: 'fas fa-wrench', color: 'from-gray-500 via-gray-400 to-gray-600', animation: 'animate-pulse', glow: 'shadow-gray-500/40', description: 'Technical debt reduction' },
        { id: 'research', name: '�📊 Research/Spike', icon: 'fas fa-search', color: 'from-indigo-500 via-purple-400 to-purple-500', animation: 'animate-pulse', glow: 'shadow-indigo-500/50', description: 'Investigation or proof of concept' },
        { id: 'documentation', name: '📝📚 Documentation', icon: 'fas fa-file-alt', color: 'from-teal-500 via-cyan-400 to-cyan-500', animation: 'animate-pulse', glow: 'shadow-teal-500/50', description: 'Documentation updates' },
        { id: 'testing', name: '🧪⚗️ Testing Task', icon: 'fas fa-vial', color: 'from-pink-500 via-rose-400 to-rose-500', animation: 'animate-pulse', glow: 'shadow-pink-500/50', description: 'Test creation or execution' },
        { id: 'deployment', name: '🚀🌟 Deployment', icon: 'fas fa-rocket', color: 'from-violet-500 via-purple-400 to-purple-500', animation: 'animate-pulse', glow: 'shadow-violet-500/50', description: 'Deployment related task' },
        { id: 'security', name: '🔒🛡️ Security', icon: 'fas fa-shield-alt', color: 'from-amber-600 via-orange-500 to-orange-600', animation: 'animate-pulse', glow: 'shadow-amber-600/50', description: 'Security enhancement or fix' },
        { id: 'performance', name: '⚡🏃 Performance', icon: 'fas fa-tachometer-alt', color: 'from-lime-500 via-green-400 to-green-500', animation: 'animate-pulse', glow: 'shadow-lime-500/50', description: 'Performance optimization' },
        { id: 'ui-ux', name: '🎨✨ UI/UX Design', icon: 'fas fa-paint-brush', color: 'from-pink-500 via-rose-400 to-rose-500', animation: 'animate-pulse', glow: 'shadow-pink-500/50', description: 'User interface or experience work' },
        { id: 'infrastructure', name: '🏗️⚙️ Infrastructure', icon: 'fas fa-server', color: 'from-slate-500 via-gray-400 to-gray-600', animation: 'animate-pulse', glow: 'shadow-slate-500/40', description: 'Infrastructure or DevOps work' },
        { id: 'integration', name: '🔌⚡ Integration', icon: 'fas fa-plug', color: 'from-blue-600 via-indigo-500 to-indigo-600', animation: 'animate-pulse', glow: 'shadow-blue-600/50', description: 'Third-party integration' },
        { id: 'maintenance', name: '🔧🛠️ Maintenance', icon: 'fas fa-tools', color: 'from-yellow-500 via-amber-400 to-amber-500', animation: 'animate-pulse', glow: 'shadow-yellow-500/50', description: 'Regular maintenance task' },
        { id: 'chore', name: '🧹✨ Chore', icon: 'fas fa-broom', color: 'from-gray-400 via-gray-300 to-gray-500', animation: 'animate-pulse', glow: 'shadow-gray-400/30', description: 'Routine administrative task' },
        { id: 'subtask', name: '🎯⭐ Subtask', icon: 'fas fa-sitemap', color: 'from-yellow-500 via-orange-400 to-yellow-600', animation: 'animate-pulse', glow: 'shadow-yellow-500/50', description: 'Sub-task of larger item' },
        { id: 'milestone', name: '🏆🎉 Milestone', icon: 'fas fa-flag-checkered', color: 'from-pink-500 via-rose-400 to-pink-600', animation: 'animate-pulse', glow: 'shadow-pink-500/50', description: 'Major project milestone' }
    ];

    // 🔥💀⚡ ULTRA PRIORITY LEVELS WITH MEGA EMOJIS 🔥💀⚡
    const priorities = [
        { id: 'lowest', name: '⚪💤 Lowest', color: 'from-gray-300 via-gray-200 to-gray-400', weight: 0, glow: 'shadow-gray-300/20', description: 'Minimal impact, can be delayed indefinitely' },
        { id: 'low', name: '🟢💚 Low', color: 'from-gray-400 via-gray-300 to-gray-500', weight: 1, glow: 'shadow-gray-500/30', description: 'Can be addressed when resources are available' },
        { id: 'medium', name: '🟡💛 Medium', color: 'from-yellow-500 via-orange-400 to-orange-500', weight: 2, glow: 'shadow-yellow-500/50', description: 'Should be addressed in current sprint' },
        { id: 'high', name: '🟠🧡 High', color: 'from-orange-500 via-red-400 to-red-500', weight: 3, glow: 'shadow-orange-500/50', description: 'Important for release, high visibility' },
        { id: 'urgent', name: '🔴❤️ URGENT', color: 'from-red-500 via-red-600 to-red-700', weight: 4, glow: 'shadow-red-500/70', description: 'Must be completed immediately' },
        { id: 'critical', name: '💀🔥 CRITICAL', color: 'from-red-700 via-red-800 to-red-900', weight: 5, glow: 'shadow-red-700/90', description: 'System breaking, all hands on deck' },
        { id: 'blocker', name: '⛔💥 BLOCKER', color: 'from-black via-red-900 to-black', weight: 6, glow: 'shadow-red-900/100', description: 'Blocks all other work, absolute highest priority' }
    ];

    // 🎯🌟💫 ULTRA STATUS TYPES WITH MEGA EFFECTS 🎯🌟💫
    const statuses = [
        { id: 'pending', name: '⏳⏰ Pending', color: 'from-gray-500 via-gray-400 to-gray-600', glow: 'shadow-gray-500/40' },
        { id: 'in-progress', name: '🔄⚡ In Progress', color: 'from-yellow-500 via-orange-400 to-orange-500', glow: 'shadow-yellow-500/60' },
        { id: 'completed', name: '✅🎉 Completed', color: 'from-green-500 via-emerald-400 to-emerald-500', glow: 'shadow-green-500/60' },
        { id: 'blocked', name: '🚫❌ Blocked', color: 'from-red-600 via-red-500 to-red-700', glow: 'shadow-red-600/60' }
    ];

    // 🏢💼 DEPARTMENTS ARRAY 🏢💼
    const departments = [
        { id: 'frontend', name: '🎨 Frontend' },
        { id: 'backend', name: '⚙️ Backend' },
        { id: 'fullstack', name: '🔧 Fullstack' },
        { id: 'devops', name: '🚀 DevOps' },
        { id: 'qa', name: '🧪 QA Testing' },
        { id: 'design', name: '🎭 UI/UX Design' },
        { id: 'product', name: '📊 Product' },
        { id: 'marketing', name: '📢 Marketing' },
        { id: 'security', name: '🛡️ Security' },
        { id: 'data', name: '📈 Data Science' }
    ];

    // 🧩⚡ COMPLEXITY LEVELS 🧩⚡
    const complexities = [
        { id: 'trivial', name: '🟢 Trivial' },
        { id: 'simple', name: '🟡 Simple' },
        { id: 'moderate', name: '🟠 Moderate' },
        { id: 'complex', name: '🔴 Complex' },
        // { id: 'epic', name: '💜 Epic Complexity' }
    ];

    // ⚠️🔥 SEVERITY LEVELS ⚠️🔥
    const severities = [
        { id: 'cosmetic', name: '🎨 Cosmetic' },
        { id: 'minor', name: '🟢 Minor' },
        { id: 'normal', name: '🟡 Normal' },
        { id: 'major', name: '🟠 Major' },
        { id: 'critical', name: '🔴 Critical' },
        { id: 'blocker', name: '⛔ Blocker' }
    ];

    // 🌍⚙️ ENVIRONMENTS 🌍⚙️
    const environments = [
        { id: 'development', name: '🛠️ Development' },
        { id: 'testing', name: '🧪 Testing' },
        { id: 'staging', name: '🎭 Staging' },
        { id: 'production', name: '🚀 Production' },
        { id: 'all', name: '🌐 All Environments' }
    ];

    // 🎯📋 TASK TYPES 🎯📋
    const taskTypes = [
        { id: 'story', name: '📖 User Story' },
        { id: 'task', name: '✅ Task' },
        { id: 'improvement', name: '⚡ Improvement' },
        { id: 'new-feature', name: '✨ New Feature' },
        { id: 'sub-task', name: '🎯 Sub-task' }
    ];

    // 💥💫 IMPACT LEVELS 💥💫
    const impactLevels = [
        { id: 'minimal', name: '🔹 Minimal' },
        { id: 'low', name: '🟢 Low' },
        { id: 'medium', name: '🟡 Medium' },
        { id: 'high', name: '🟠 High' },
        { id: 'critical', name: '🔴 Critical' },
        { id: 'massive', name: '💥 Massive' }
    ];

    // ⚡🏃 EFFORT LEVELS ⚡🏃
    const effortLevels = [
        { id: 'xs', name: '🔸 XS (< 1h)' },
        { id: 's', name: '🟢 S (1-4h)' },
        { id: 'm', name: '🟡 M (1-2 days)' },
        { id: 'l', name: '🟠 L (3-5 days)' },
        { id: 'xl', name: '🔴 XL (1-2 weeks)' },
        { id: 'xxl', name: '💜 XXL (2+ weeks)' }
    ];

    // 🔥🚀💥 FETCH TODOS WITH REAL-TIME ULTRA MEGA UPDATES 🔥🚀💥
    useEffect(() => {
        if (!user || !db) return;

        const todosCollectionRef = collection(db, 'todos');
        const q = query(todosCollectionRef, orderBy('createdAt', 'desc'));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedTodos = snapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    createdAt: data.createdAt?.toDate?.() || new Date(),
                    subtasks: data.subtasks || [],
                    isExpanded: expandedTodos.has(doc.id)
                };
            });
            setTodos(fetchedTodos);
            setAnimationTrigger(prev => prev + 1);
            
            // Disabled particle explosion for performance
            // createParticleExplosion();
        }, (error) => {
            console.error('Error fetching todos:', error);
            setModalMessage('Failed to fetch todos: ' + error.message);
        });

        return () => unsubscribe();
    }, [user, db, setModalMessage, expandedTodos]);

    // 🌟💥⚡ ULTRA PARTICLE EXPLOSION CREATOR 🌟💥⚡
    const createParticleExplosion = () => {
        const particles = [];
        for (let i = 0; i < 20; i++) {
            particles.push({
                id: Math.random(),
                x: Math.random() * window.innerWidth,
                y: Math.random() * window.innerHeight,
                color: `hsl(${Math.random() * 360}, 100%, 60%)`,
                size: Math.random() * 8 + 4,
                velocity: {
                    x: (Math.random() - 0.5) * 10,
                    y: (Math.random() - 0.5) * 10
                }
            });
        }
        setFloatingElements(particles);
        setTimeout(() => setFloatingElements([]), 3000);
    };

    // 🎯 FILTERING AND SEARCHING 🎯
    useEffect(() => {
        let filtered = [...todos];

        if (filter !== 'all') {
            filtered = filtered.filter(todo => todo.status === filter);
        }
        if (priority !== 'all') {
            filtered = filtered.filter(todo => todo.priority === priority);
        }
        if (searchTerm) {
            const searchLower = searchTerm.toLowerCase();
            filtered = filtered.filter(todo => 
                todo.title.toLowerCase().includes(searchLower) ||
                (todo.description && todo.description.toLowerCase().includes(searchLower))
            );
        }

        setFilteredTodos(filtered);
    }, [todos, filter, priority, searchTerm]);

    // 💥🚀⚡ ULTRA MEGA ADD TODO WITH INFINITE NESTING FUNCTION 💥🚀⚡
    const handleAddTodo = async (parentId = null) => {
        const todoText = parentId ? newSubtask : newTodo;
        console.log('HandleAddTodo called with:', { parentId, todoText, newTodo, newSubtask });
        
        if (!todoText.trim()) {
            console.log('Empty todo text detected:', todoText);
            setModalMessage('❌ Please enter a todo title!');
            return;
        }

        const setAdding = parentId ? setIsAddingSubtask : setIsAdding;
        setAdding(true);
        
        try {
            const todosCollectionRef = collection(db, 'todos');
            
            const newTodoData = {
                title: todoText.trim(),
                description: parentId ? newSubtaskDescription : newTodoDescription,
                priority: parentId ? newSubtaskPriority : newTodoPriority,
                category: parentId ? newSubtaskCategory : newTodoCategory,
                status: 'pending',
                completed: false,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
                createdBy: user.email,
                parentId: parentId,
                subtasks: [],
                nestingLevel: parentId ? (await getNestingLevel(parentId)) + 1 : 0,
                
                // 🚀💫 ULTRA SUPREME ADVANCED FIELDS FROM CORRUPTED BACKUP 🚀💫
                ...(parentId ? {} : {
                    // Time Tracking
                    estimatedHours: newTodoEstimatedHours || 0,
                    storyPoints: newTodoStoryPoints || '',
                    dueDate: newTodoDueDate || null,
                    sprint: newTodoSprint || '',
                    
                    // Assignment & Team
                    assignedTo: newTodoAssignedTo || '',
                    department: newTodoDepartment || '',
                    epicLink: newTodoEpicLink || '',
                    dependencies: newTodoDependencies || '',
                    
                    // Technical & Quality
                    complexity: newTodoComplexity || '',
                    severity: newTodoSeverity || '',
                    environment: newTodoEnvironment || '',
                    taskType: newTodoTaskType || '',
                    
                    // Business & Impact
                    impactLevel: newTodoImpactLevel || '',
                    effortLevel: newTodoEffortLevel || '',
                    businessValue: newTodoBusinessValue || '',
                    acceptanceCriteria: newTodoAcceptanceCriteria || '',
                    
                    // Advanced Tracking
                    labels: newTodoLabels || '',
                    externalLinks: newTodoExternalLinks || '',
                    progress: newTodoProgress || 0,
                    performanceImpact: newTodoPerformanceImpact || '',
                    monitoringNeeds: newTodoMonitoringNeeds || '',
                    
                    // Risk & Security
                    riskLevel: newTodoRiskLevel || 'low',
                    securityNotes: newTodoSecurityNotes || '',
                    testingStrategy: newTodoTestingStrategy || ''
                })
            };
            
            const docRef = await addDoc(todosCollectionRef, newTodoData);
            
            // Disabled explosion effects for performance
            // if (explosionEffects && ultraAnimations) {
            //     setExplosionEffects(prev => ({
            //         ...prev,
            //         [docRef.id]: true
            //     }));
            //     setTimeout(() => {
            //         setExplosionEffects(prev => {
            //             const newEffects = { ...prev };
            //             delete newEffects[docRef.id];
            //             return newEffects;
            //         });
            //     }, 2000);
            // }
            
            if (parentId) {
                setNewSubtask('');
                setNewSubtaskDescription('');
                setNewSubtaskPriority('medium');
                setNewSubtaskCategory('subtask');
                setAddingSubtaskTo(null);
                setModalMessage('🎉💫 SUBTASK created! 🎉💫');
            } else {
                setNewTodo('');
                setNewTodoDescription('');
                setNewTodoPriority('medium');
                setNewTodoCategory('feature');
                
                // 🚀💫 CLEAR ALL ULTRA SUPREME ADVANCED FIELDS 🚀💫
                setNewTodoEstimatedHours('');
                setNewTodoStoryPoints('');
                setNewTodoDueDate('');
                setNewTodoSprint('');
                setNewTodoAssignedTo('');
                setNewTodoDepartment('');
                setNewTodoEpicLink('');
                setNewTodoDependencies('');
                setNewTodoComplexity('');
                setNewTodoSeverity('');
                setNewTodoEnvironment('');
                setNewTodoTaskType('');
                setNewTodoImpactLevel('');
                setNewTodoEffortLevel('');
                setNewTodoBusinessValue('');
                setNewTodoAcceptanceCriteria('');
                setNewTodoLabels('');
                setNewTodoExternalLinks('');
                setNewTodoProgress(0);
                setNewTodoPerformanceImpact('');
                setNewTodoMonitoringNeeds('');
                setNewTodoRiskLevel('low');
                setNewTodoSecurityNotes('');
                setNewTodoTestingStrategy('');
                
                setModalMessage('🎉🚀 TODO created! 🎉🚀');
                setShowAddForm(false);
                setShowAdvancedForm(false);
            }
            
            // Disabled particle explosion for performance
            // createParticleExplosion();
            
        } catch (error) {
            console.error('Error adding todo:', error);
            setModalMessage('❌ Failed to add todo: ' + error.message);
        } finally {
            setAdding(false);
        }
    };

    // 🎯📊 GET NESTING LEVEL FOR INFINITE DEPTH 🎯📊
    const getNestingLevel = async (todoId) => {
        const todo = todos.find(t => t.id === todoId);
        if (!todo || !todo.parentId) return 0;
        return (await getNestingLevel(todo.parentId)) + 1;
    };

    // 🌟💫 TOGGLE EXPANSION WITH MEGA ANIMATIONS 🌟💫
    const toggleTodoExpansion = (todoId) => {
        setExpandedTodos(prev => {
            const newExpanded = new Set(prev);
            if (newExpanded.has(todoId)) {
                newExpanded.delete(todoId);
            } else {
                newExpanded.add(todoId);
            }
            return newExpanded;
        });
        
        // 🎆💥 ULTRA EXPANSION ANIMATION EFFECT 🎆💥
        if (ultraAnimations) {
            setExplosionEffects(prev => ({
                ...prev,
                [`expand_${todoId}`]: true
            }));
            setTimeout(() => {
                setExplosionEffects(prev => {
                    const newEffects = { ...prev };
                    delete newEffects[`expand_${todoId}`];
                    return newEffects;
                });
            }, 1000);
        }
    };

    // ⚡ UPDATE TODO STATUS ⚡
    const updateTodoStatus = async (todoId, newStatus) => {
        try {
            const todoDoc = doc(db, 'todos', todoId);
            await updateDoc(todoDoc, {
                status: newStatus,
                updatedAt: serverTimestamp(),
                ...(newStatus === 'completed' && { completedAt: serverTimestamp() })
            });
            setModalMessage(`🎯 Status updated to ${newStatus}! 🎯`);
        } catch (error) {
            console.error('Error updating todo status:', error);
            setModalMessage('❌ Failed to update status: ' + error.message);
        }
    };

    // 🗑️ DELETE TODO 🗑️
    const deleteTodo = async (todoId) => {
        if (!window.confirm('🔥 Are you sure you want to delete this todo? 🔥')) {
            return;
        }

        try {
            await deleteDoc(doc(db, 'todos', todoId));
            setModalMessage('💥 Todo deleted successfully! 💥');
        } catch (error) {
            console.error('Error deleting todo:', error);
            setModalMessage('❌ Failed to delete todo: ' + error.message);
        }
    };

    // 🎨 GET CATEGORY STYLE 🎨
    const getCategoryStyle = (categoryId) => {
        const category = categories.find(c => c.id === categoryId);
        return category || categories[0];
    };

    // 🔥 GET PRIORITY STYLE 🔥
    const getPriorityStyle = (priorityId) => {
        const priority = priorities.find(p => p.id === priorityId);
        return priority || priorities[1];
    };

    // 🎯💫⚡ GET STATUS STYLE WITH MEGA GLOW 🎯💫⚡
    const getStatusStyle = (statusId) => {
        const status = statuses.find(s => s.id === statusId);
        return status || statuses[0];
    };

    // 🌟🔥💥 RECURSIVE TODO RENDERER WITH INFINITE NESTING AND ULTRA ANIMATIONS 🌟🔥💥
    const renderTodoWithSubtasks = (todo, depth = 0) => {
        const categoryStyle = getCategoryStyle(todo.category);
        const priorityStyle = getPriorityStyle(todo.priority);
        const statusStyle = getStatusStyle(todo.status);
        const isExpanded = expandedTodos.has(todo.id);
        const hasSubtasks = todos.filter(t => t.parentId === todo.id).length > 0;
        const subtasks = todos.filter(t => t.parentId === todo.id);
        const isHovered = hoveredTodo === todo.id;
        const hasExplosion = explosionEffects[todo.id] || explosionEffects[`expand_${todo.id}`];
        
        // 🎨🌈 ULTRA DEPTH-BASED STYLING 🎨🌈
        const depthStyles = [
            'ml-0 border-l-4 border-transparent',
            'ml-6 border-l-4 border-blue-500/50 bg-blue-500/5',
            'ml-12 border-l-4 border-purple-500/50 bg-purple-500/5', 
            'ml-18 border-l-4 border-pink-500/50 bg-pink-500/5',
            'ml-24 border-l-4 border-green-500/50 bg-green-500/5',
            'ml-30 border-l-4 border-yellow-500/50 bg-yellow-500/5',
            'ml-36 border-l-4 border-red-500/50 bg-red-500/5'
        ];
        const currentDepthStyle = depthStyles[Math.min(depth, depthStyles.length - 1)];
        
        return (
            <div key={todo.id} className={`group relative animate-slideInUp ${currentDepthStyle}`}>
                {/* 🌟💥 ULTRA EXPLOSION PARTICLE EFFECTS 🌟💥 */}
                {/* {hasExplosion && (
                    <div className="absolute inset-0 pointer-events-none z-50">
                        {[...Array(15)].map((_, i) => (
                            <div
                                key={i}
                                className={`absolute w-4 h-4 bg-gradient-to-r ${priorityStyle.color} rounded-full animate-ping opacity-70`}
                                style={{
                                    left: `${Math.random() * 100}%`,
                                    top: `${Math.random() * 100}%`,
                                    animationDelay: `${i * 0.1}s`,
                                    animationDuration: '2s'
                                }}
                            />
                        ))}
                    </div>
                )} */}

                {/* 🔥🌈 ULTRA GLOW EFFECTS 🔥🌈 */}
                <div className={`absolute -inset-1 bg-gradient-to-r ${priorityStyle.color} opacity-${isHovered ? '60' : '30'} rounded-2xl blur-sm transition-all duration-500 ${priorityStyle.glow}`}></div>
                
                {/* 🎯💎 MAIN TODO CARD WITH MEGA ANIMATIONS 🎯💎 */}
                <div 
                    className={`relative glass-card-professional p-6 rounded-2xl border border-white/10 hover:border-blue-400/50 transition-all duration-300 overflow-hidden`}
                    onMouseEnter={() => setHoveredTodo(todo.id)}
                    onMouseLeave={() => setHoveredTodo(null)}
                    onDragStart={() => setDraggedTodo(todo.id)}
                    onDragEnd={() => setDraggedTodo(null)}
                    draggable={true}
                >
                    {/* Simple hover shimmer effect */}
                    <div className={`absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent ${isHovered ? 'translate-x-full' : '-translate-x-full'} transition-transform duration-1000 rounded-2xl pointer-events-none`}></div>
                    
                    {/* 🎨🔥 RAINBOW MODE EFFECTS 🎨🔥 */}
                    {/* {rainbowMode && (
                        <div className="absolute inset-0 bg-gradient-to-r from-red-500 via-yellow-500 via-green-500 via-blue-500 via-indigo-500 to-purple-500 opacity-20 rounded-2xl animate-pulse"></div>
                    )} */}
                    
                    <div className="relative">
                        {/* 🎯💎 TODO HEADER WITH EXPANSION CONTROLS 🎯💎 */}
                        <div className="flex items-start justify-between mb-4">
                            <div className="flex-1">
                                <div className="flex items-center space-x-3 mb-2">
                                    {/* 🌟⚡ EXPANSION TOGGLE WITH ULTRA ANIMATIONS 🌟⚡ */}
                                    {hasSubtasks && (
                                        <button
                                            onClick={() => toggleTodoExpansion(todo.id)}
                                            className={`group/expand relative w-8 h-8 rounded-full bg-gradient-to-r ${categoryStyle.color} flex items-center justify-center transition-all duration-300 hover:scale-110 ${categoryStyle.glow} shadow-lg`}
                                        >
                                            <i className={`fas ${isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'} text-white text-sm group-hover/expand:scale-110 transition-all duration-300`}></i>
                                        </button>
                                    )}
                                    
                                    {/* 🎨🌈 CATEGORY BADGES - OPTIMIZED 🎨🌈 */}
                                    <div className={`relative px-3 py-1 rounded-full text-xs font-bold bg-gradient-to-r ${categoryStyle.color} text-white shadow-md hover:scale-105 transition-transform duration-200 cursor-pointer`}>
                                        <span>{categoryStyle.name}</span>
                                    </div>
                                    
                                    {/* 🔥💀 PRIORITY BADGES - OPTIMIZED 🔥💀 */}
                                    <div className={`relative px-3 py-1 rounded-full text-xs font-bold bg-gradient-to-r ${priorityStyle.color} text-white shadow-md hover:scale-105 transition-transform duration-200 cursor-pointer`}>
                                        <span>{priorityStyle.name}</span>
                                    </div>
                                    
                                    {/* 🎯🌟 STATUS BADGES - OPTIMIZED 🎯🌟 */}
                                    <div className={`relative px-3 py-1 rounded-full text-xs font-bold bg-gradient-to-r ${statusStyle.color} text-white shadow-md hover:scale-105 transition-transform duration-200 cursor-pointer`}>
                                        <span>{statusStyle.name}</span>
                                    </div>
                                    
                                    {/* 📊💎 SUBTASK COUNTER WITH ANIMATIONS 📊💎 */}
                                    {hasSubtasks && (
                                        <div className="px-3 py-1 rounded-full text-xs font-bold bg-gradient-to-r from-indigo-500 to-purple-500 text-white animate-pulse shadow-lg">
                                            🎯 {subtasks.length} subtasks
                                        </div>
                                    )}
                                    
                                    {/* 🎨📏 DEPTH INDICATOR 🎨📏 */}
                                    {depth > 0 && (
                                        <div className="px-2 py-1 rounded-full text-xs bg-white/20 text-white animate-pulse">
                                            Level {depth}
                                        </div>
                                    )}
                                </div>
                                
                                {/* 🔥📝 TITLE WITH MEGA HOVER EFFECTS 🔥📝 */}
                                <h3 className="text-xl font-bold text-white mb-2">
                                    {todo.title}
                                </h3>
                                
                                {/* 📖💫 DESCRIPTION WITH ANIMATIONS 📖💫 */}
                                {todo.description && (
                                    <p className="text-gray-300 text-sm mb-3">
                                        {todo.description}
                                    </p>
                                )}
                                
                                {/* 🕰️💎 METADATA WITH GLOW 🕰️💎 */}
                                <div className="text-xs text-gray-400 space-y-1">
                                    <div>Created: {todo.createdAt?.toLocaleString()} by {todo.createdBy}</div>
                                    {todo.nestingLevel > 0 && (
                                        <div className="text-blue-400 animate-pulse">🎯 Nesting Level: {todo.nestingLevel}</div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* 🎮🚀 ACTION BUTTONS WITH ULTRA ANIMATIONS 🎮🚀 */}
                        <div className="flex items-center justify-between">
                            <div className="flex space-x-2">
                                {/* 🌟🚀 STATUS PROGRESSION BUTTONS 🌟🚀 */}
                                {todo.status === 'pending' && (
                                    <button
                                        onClick={() => updateTodoStatus(todo.id, 'in-progress')}
                                        className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white px-4 py-2 rounded-lg font-medium transition-all duration-300 hover:scale-105 shadow-lg"
                                    >
                                        <i className="fas fa-play text-sm mr-2"></i>
                                        <span>▶️ Start</span>
                                    </button>
                                )}
                                
                                {todo.status === 'in-progress' && (
                                    <button
                                        onClick={() => updateTodoStatus(todo.id, 'completed')}
                                        className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white px-4 py-2 rounded-lg font-medium transition-all duration-300 hover:scale-105 shadow-lg"
                                    >
                                        <i className="fas fa-check text-sm mr-2"></i>
                                        <span>✅ Complete</span>
                                    </button>
                                )}
                                
                                {todo.status === 'completed' && (
                                    <div className="flex items-center space-x-2 text-green-400 font-bold px-4 py-2 bg-green-500/20 rounded-xl animate-pulse">
                                        <i className="fas fa-trophy animate-pulse"></i>
                                        <span>🎉 COMPLETED!</span>
                                        <div className="w-3 h-3 bg-green-400 rounded-full animate-ping"></div>
                                    </div>
                                )}

                                {/* 🎯➕ ADD SUBTASK BUTTON WITH MEGA ANIMATIONS 🎯➕ */}
                                <button
                                    onClick={() => setAddingSubtaskTo(addingSubtaskTo === todo.id ? null : todo.id)}
                                    className="bg-gradient-to-r from-yellow-600 to-orange-600 hover:from-yellow-500 hover:to-orange-500 text-white px-4 py-2 rounded-lg font-medium transition-all duration-300 hover:scale-105 shadow-lg"
                                >
                                    <i className="fas fa-plus text-sm mr-2"></i>
                                    <span>🎯 ADD SUBTASK</span>
                                </button>
                            </div>

                            {/* 🗑️💥 DELETE BUTTON WITH ULTRA EFFECTS 🗑️💥 */}
                            <div className="flex space-x-2">
                                <button
                                    onClick={() => deleteTodo(todo.id)}
                                    className="bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-500 hover:to-pink-500 text-white p-3 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg"
                                    title="Delete Todo"
                                >
                                    <i className="fas fa-trash text-sm"></i>
                                </button>
                            </div>
                        </div>

                        {/* 🎯📝 SUBTASK ADDITION FORM WITH ULTRA ANIMATIONS 🎯📝 */}
                        {addingSubtaskTo === todo.id && (
                            <div className="mt-6 p-6 bg-white/5 rounded-2xl border border-white/10 animate-slideInUp">
                                <h4 className="text-lg font-bold text-white mb-4 flex items-center">
                                    <i className="fas fa-plus-circle text-yellow-400 mr-3 animate-spin"></i>
                                    🎯 Add Subtask
                                </h4>
                                
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <input
                                            type="text"
                                            placeholder="Enter subtask title..."
                                            value={newSubtask}
                                            onChange={(e) => setNewSubtask(e.target.value)}
                                            className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-3 text-white placeholder-gray-400 focus:border-yellow-400 focus:outline-none transition-all hover:bg-white/15 focus:scale-105"
                                        />
                                    </div>
                                    <div>
                                        <textarea
                                            placeholder="Subtask description..."
                                            value={newSubtaskDescription}
                                            onChange={(e) => setNewSubtaskDescription(e.target.value)}
                                            rows="2"
                                            className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-yellow-400 focus:outline-none transition-all hover:bg-white/15 resize-none"
                                        />
                                    </div>
                                </div>
                                
                                <div className="grid grid-cols-2 gap-4 mb-4">
                                    <select
                                        value={newSubtaskPriority}
                                        onChange={(e) => setNewSubtaskPriority(e.target.value)}
                                        className="bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-yellow-400 focus:outline-none"
                                    >
                                        {priorities.map(prio => (
                                            <option key={prio.id} value={prio.id} className="bg-gray-800">{prio.name}</option>
                                        ))}
                                    </select>
                                    <select
                                        value={newSubtaskCategory}
                                        onChange={(e) => setNewSubtaskCategory(e.target.value)}
                                        className="bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-yellow-400 focus:outline-none"
                                    >
                                        {categories.map(cat => (
                                            <option key={cat.id} value={cat.id} className="bg-gray-800">{cat.name}</option>
                                        ))}
                                    </select>
                                </div>
                                
                                <div className="flex justify-end space-x-3">
                                    <button
                                        onClick={() => setAddingSubtaskTo(null)}
                                        className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-all hover:scale-105"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={() => handleAddTodo(todo.id)}
                                        disabled={isAddingSubtask || !newSubtask.trim()}
                                        className="px-6 py-2 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white rounded-lg font-semibold transition-all duration-300 hover:scale-110 disabled:opacity-50"
                                    >
                                        {isAddingSubtask ? (
                                            <>
                                                <i className="fas fa-spinner fa-spin mr-2"></i>
                                                Creating...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-rocket mr-2"></i>
                                                🎯 Create Subtask
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* 🌟🎯 RECURSIVE SUBTASKS WITH INFINITE NESTING 🌟🎯 */}
                {isExpanded && hasSubtasks && (
                    <div className="mt-4 space-y-4 animate-slideInUp">
                        {subtasks.map(subtask => renderTodoWithSubtasks(subtask, depth + 1))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white p-6 overflow-x-hidden">
            {/* 🌟�⚡ ULTRA MEGA ANIMATED BACKGROUND WITH INFINITE PARTICLES 🌟�⚡ */}
            <div className="fixed inset-0 pointer-events-none z-0">
                <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl opacity-50"></div>
                <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-purple-500/5 rounded-full blur-3xl opacity-40"></div>
                
                {/* Removed floating particle effects for better performance */}
                
                {/* 🌈🔥 RAINBOW MODE BACKGROUND 🌈🔥 */}
                {rainbowMode && (
                    <div className="absolute inset-0 bg-gradient-to-r from-red-500/10 via-yellow-500/10 via-green-500/10 via-blue-500/10 via-indigo-500/10 to-purple-500/10 animate-pulse"></div>
                )}
            </div>

            {/* 🚀🔥💫 ULTRA MODERN SLEEK HEADER 🚀🔥💫 */}
                <div className="relative z-10 animate-slideInLeft">
                <div className="glass-card-ultra rounded-3xl p-8 mb-8 relative overflow-hidden group">
                    {/* Optimized background particles */}
                    <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                        <div className="absolute top-4 left-1/4 w-2 h-2 bg-blue-400/30 rounded-full animate-pulse" style={{animationDelay: '0s'}}></div>
                        <div className="absolute bottom-6 right-1/3 w-1 h-1 bg-cyan-300/40 rounded-full animate-pulse" style={{animationDelay: '1s'}}></div>
                    </div>                    {/* Optimized modern glow effect */}
                    <div className="absolute -inset-1 bg-gradient-to-r from-slate-900/40 via-blue-900/20 to-slate-900/40 rounded-3xl blur-lg opacity-50 group-hover:opacity-80 transition-all duration-500"></div>
                    
                    <div className="relative flex items-center justify-between">
                        <div className="flex items-center space-x-6">
                            <button
                                onClick={onBackToPanel}
                                className="bg-gradient-to-r from-slate-800/80 to-slate-700/80 hover:from-blue-900/80 hover:to-indigo-900/80 text-white p-3 rounded-xl transition-all duration-300 hover:scale-105 shadow-lg backdrop-blur-sm border border-white/10 hover:border-blue-400/30"
                            >
                                <i className="fas fa-arrow-left text-lg transition-all duration-300"></i>
                            </button>
                            
                            <div className="relative">
                                <h1 className="text-5xl font-black bg-gradient-to-r from-slate-100 via-blue-200 to-cyan-200 bg-clip-text text-transparent group-hover/title:from-blue-300 group-hover/title:via-cyan-300 group-hover/title:to-indigo-300 transition-all duration-500">
                                    PANEL TODO
                                </h1>
                                
                                {/* Simple underline */}
                                <div className="absolute -bottom-1 left-0 right-0 h-0.5 bg-gradient-to-r from-blue-500/40 via-cyan-400/60 to-blue-500/40 rounded-full"></div>
                            </div>
                        </div>

                        <div className="flex items-center space-x-4">
                            <button
                                onClick={() => setShowStats(!showStats)}
                                className="bg-gradient-to-r from-emerald-900/60 to-green-900/60 hover:from-emerald-800/80 hover:to-green-800/80 text-white px-4 py-2 rounded-lg font-bold transition-all duration-300 hover:scale-105 shadow-lg backdrop-blur-sm border border-emerald-500/20 hover:border-emerald-400/40"
                            >
                                <i className="fas fa-chart-bar mr-2 transition-all duration-300"></i>
                                <span>Stats</span>
                            </button>
                            
                            <button
                                onClick={() => setShowAddForm(!showAddForm)}
                                className="bg-gradient-to-r from-blue-900/60 to-indigo-900/60 hover:from-blue-800/80 hover:to-indigo-800/80 text-white px-6 py-3 rounded-xl font-bold text-lg transition-all duration-300 hover:scale-105 shadow-lg backdrop-blur-sm border border-blue-500/20 hover:border-cyan-400/40"
                            >
                                <div className="flex items-center space-x-3">
                                    <div className="w-6 h-6 rounded-full bg-gradient-to-r from-blue-500/30 to-cyan-500/30 flex items-center justify-center backdrop-blur-sm border border-white/20">
                                        <i className="fas fa-plus text-sm"></i>
                                    </div>
                                    <span>✨ Add New Todo</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* 📊 STATS DASHBOARD 📊 */}
            {showStats && (
                <div className="relative z-10 animate-slideInRight mb-8">
                    <div className="glass-card rounded-3xl p-8 relative overflow-hidden">
                        <div className="absolute -inset-2 bg-gradient-to-r from-green-500/10 via-blue-500/10 to-purple-500/10 rounded-3xl blur-xl animate-pulse"></div>
                        
                        <div className="relative">
                            <h2 className="text-3xl font-bold bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent mb-6">
                                🚀 Project Statistics Dashboard 🚀
                            </h2>
                            
                            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                                {[
                                    { label: 'Total', value: todos.length, icon: 'fas fa-tasks', color: 'from-blue-500 to-cyan-500' },
                                    { label: 'Completed', value: todos.filter(t => t.status === 'completed').length, icon: 'fas fa-check-circle', color: 'from-green-500 to-emerald-500' },
                                    { label: 'In Progress', value: todos.filter(t => t.status === 'in-progress').length, icon: 'fas fa-spinner', color: 'from-yellow-500 to-orange-500' },
                                    { label: 'Pending', value: todos.filter(t => t.status === 'pending').length, icon: 'fas fa-clock', color: 'from-gray-500 to-gray-600' },
                                    { label: 'Urgent', value: todos.filter(t => t.priority === 'urgent' || t.priority === 'critical').length, icon: 'fas fa-exclamation-triangle', color: 'from-red-500 to-pink-500' }
                                ].map((stat, index) => (
                                    <div key={stat.label} className="group relative animate-pulse" style={{ animationDelay: `${index * 0.1}s` }}>
                                        <div className={`absolute inset-0 bg-gradient-to-r ${stat.color} opacity-20 rounded-2xl blur-lg group-hover:opacity-40 transition-opacity duration-300`}></div>
                                        <div className="relative glass-card p-6 rounded-2xl border border-white/20 hover:border-white/40 transition-all duration-300 hover:scale-105 hover:-translate-y-2">
                                            <div className="flex items-center space-x-3">
                                                <div className={`w-12 h-12 rounded-xl bg-gradient-to-r ${stat.color} flex items-center justify-center group-hover:rotate-12 transition-transform duration-300`}>
                                                    <i className={`${stat.icon} text-white text-lg group-hover:scale-110 transition-transform duration-300`}></i>
                                                </div>
                                                <div>
                                                    <div className="text-3xl font-bold text-white group-hover:scale-110 transition-transform duration-300">{stat.value}</div>
                                                    <div className="text-sm text-gray-400 group-hover:text-gray-300 transition-colors duration-300">{stat.label}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 🎛️ FILTERS AND CONTROLS 🎛️ */}
            <div className="relative z-10 animate-fadeIn mb-8">
                <div className="glass-card rounded-2xl p-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">🔍 Search</label>
                            <div className="relative">
                                <input
                                    type="text"
                                    placeholder="Search todos..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 pl-10 text-white placeholder-gray-400 focus:border-blue-400 focus:outline-none transition-colors hover:bg-white/15"
                                />
                                <i className="fas fa-search absolute left-3 top-3 text-gray-400"></i>
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">📊 Status Filter</label>
                            <select
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-blue-400 focus:outline-none transition-colors hover:bg-white/15"
                            >
                                <option value="all" className="bg-gray-800">All Status</option>
                                {statuses.map(status => (
                                    <option key={status.id} value={status.id} className="bg-gray-800">{status.name}</option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-300 mb-2">🔥 Priority Filter</label>
                            <select
                                value={priority}
                                onChange={(e) => setPriority(e.target.value)}
                                className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-blue-400 focus:outline-none transition-colors hover:bg-white/15"
                            >
                                <option value="all" className="bg-gray-800">All Priorities</option>
                                {priorities.map(prio => (
                                    <option key={prio.id} value={prio.id} className="bg-gray-800">{prio.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            {/* 📝 OPTIMIZED ADD TODO FORM 📝 */}
            {showAddForm && (
                <div className="relative z-10 mb-8">
                    {/* Sleek backdrop with optimized blur */}
                    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm -z-10"></div>
                    
                    <div className="glass-card-sleek rounded-2xl p-8 relative overflow-hidden shadow-2xl border border-white/10">
                        {/* Subtle animated background gradient */}
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/10 via-indigo-900/10 to-purple-900/10 rounded-2xl"></div>
                        
                        {/* Simple shimmer effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full animate-gentle-shimmer rounded-2xl"></div>
                        
                        <div className="relative">
                            <h2 className="text-3xl font-bold text-white mb-8 flex items-center">
                                <div className="w-10 h-10 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 flex items-center justify-center mr-4 shadow-lg">
                                    <i className="fas fa-plus text-white text-lg"></i>
                                </div>
                                {editingTodo ? '✏️ Edit Todo' : '✨ Create New Todo'}
                            </h2>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                <div className="space-y-6">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-200 mb-3">📝 Title *</label>
                                        <input
                                            type="text"
                                            placeholder="Enter todo title..."
                                            value={newTodo}
                                            onChange={(e) => setNewTodo(e.target.value)}
                                            className="w-full bg-gray-900/90 border border-gray-700/60 rounded-xl px-5 py-4 text-white placeholder-gray-400 focus:border-blue-400/60 focus:outline-none transition-all duration-300 hover:bg-gray-800/90 focus:bg-gray-800/90 backdrop-blur-sm shadow-inner"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-200 mb-3">📖 Description</label>
                                        <textarea
                                            placeholder="Enter detailed description..."
                                            value={newTodoDescription}
                                            onChange={(e) => setNewTodoDescription(e.target.value)}
                                            rows="4"
                                            className="w-full bg-gray-900/90 border border-gray-700/60 rounded-xl px-5 py-4 text-white placeholder-gray-400 focus:border-blue-400/60 focus:outline-none transition-all duration-300 hover:bg-gray-800/90 focus:bg-gray-800/90 resize-none backdrop-blur-sm shadow-inner"
                                        />
                                    </div>
                                </div>
                                
                                <div className="space-y-6">
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-200 mb-3">🔥 Priority</label>
                                        <select
                                            value={newTodoPriority}
                                            onChange={(e) => setNewTodoPriority(e.target.value)}
                                            className="w-full bg-gray-900/90 border border-gray-700/60 rounded-xl px-5 py-4 text-white focus:border-blue-400/60 focus:outline-none transition-all duration-300 hover:bg-gray-800/90 backdrop-blur-sm shadow-inner"
                                        >
                                            {priorities.map(prio => (
                                                <option key={prio.id} value={prio.id} className="bg-gray-900 text-white">{prio.name} - {prio.description}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-semibold text-gray-200 mb-3">🎨 Category</label>
                                        <select
                                            value={newTodoCategory}
                                            onChange={(e) => setNewTodoCategory(e.target.value)}
                                            className="w-full bg-gray-900/90 border border-gray-700/60 rounded-xl px-5 py-4 text-white focus:border-blue-400/60 focus:outline-none transition-all duration-300 hover:bg-gray-800/90 backdrop-blur-sm shadow-inner"
                                        >
                                            {categories.map(cat => (
                                                <option key={cat.id} value={cat.id} className="bg-gray-900 text-white">{cat.name} - {cat.description}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* 🌟 SLEEK ADVANCED FORM TOGGLE 🌟 */}
                            <div className="mt-8">
                                <button
                                    type="button"
                                    onClick={() => setShowAdvancedForm(!showAdvancedForm)}
                                    className="group relative px-8 py-4 bg-gradient-to-r from-indigo-600/80 to-purple-600/80 hover:from-indigo-500/90 hover:to-purple-500/90 text-white rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl backdrop-blur-sm border border-white/10"
                                >
                                    <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl"></div>
                                    <div className="relative flex items-center">
                                        <i className={`fas ${showAdvancedForm ? 'fa-chevron-up' : 'fa-chevron-down'} mr-3 transition-transform duration-300 ${showAdvancedForm ? 'rotate-180' : ''}`}></i>
                                        {showAdvancedForm ? '🔼 Hide Advanced Fields' : '🔽 Show Advanced Fields (Project Management)'}
                                    </div>
                                </button>
                            </div>

                            {/* 🚀💫 ULTRA ADVANCED PROJECT MANAGEMENT FIELDS FROM CORRUPTED BACKUP 🚀💫 */}
            {showAdvancedForm && (
                <div className="mt-8 p-8 bg-gradient-to-br from-slate-900/50 to-indigo-900/50 rounded-2xl border border-white/10 transition-all duration-500 backdrop-blur-sm">
                    <h3 className="text-2xl font-bold text-white mb-6 flex items-center">
                        <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-500 to-indigo-500 flex items-center justify-center mr-3">
                            <i className="fas fa-cog text-white text-sm"></i>
                        </div>
                        ⚙️ Advanced Project Management Fields
                    </h3>                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                        {/* Time Tracking Section */}
                                        <div className="space-y-4 p-4 bg-blue-900/20 rounded-lg border border-blue-400/30">
                                            <h4 className="text-lg font-semibold text-blue-300">⏰ Time Tracking</h4>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">⌛ Estimated Hours</label>
                                                <input
                                                    type="number"
                                                    placeholder="0"
                                                    value={newTodoEstimatedHours}
                                                    onChange={(e) => setNewTodoEstimatedHours(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-blue-400 focus:outline-none transition-all hover:bg-white/15"
                                                />
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">📊 Story Points</label>
                                                <select
                                                    value={newTodoStoryPoints}
                                                    onChange={(e) => setNewTodoStoryPoints(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-blue-400 focus:outline-none transition-all hover:bg-white/15"
                                                >
                                                    <option value="" className="bg-gray-800">Select Points</option>
                                                    <option value="1" className="bg-gray-800">1 - Trivial</option>
                                                    <option value="2" className="bg-gray-800">2 - Easy</option>
                                                    <option value="3" className="bg-gray-800">3 - Medium</option>
                                                    <option value="5" className="bg-gray-800">5 - Hard</option>
                                                    <option value="8" className="bg-gray-800">8 - Very Hard</option>
                                                    {/* <option value="13" className="bg-gray-800">13 - Epic</option>
                                                    <option value="21" className="bg-gray-800">21 - Legendary</option> */}
                                                </select>
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">📅 Due Date</label>
                                                <input
                                                    type="datetime-local"
                                                    value={newTodoDueDate}
                                                    onChange={(e) => setNewTodoDueDate(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-blue-400 focus:outline-none transition-all hover:bg-white/15"
                                                />
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🏁 Sprint</label>
                                                <input
                                                    type="text"
                                                    placeholder="Sprint 2024.1"
                                                    value={newTodoSprint}
                                                    onChange={(e) => setNewTodoSprint(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-blue-400 focus:outline-none transition-all hover:bg-white/15"
                                                />
                                            </div>
                                        </div>

                                        {/* Assignment & Team Section */}
                                        <div className="space-y-4 p-4 bg-green-900/20 rounded-lg border border-green-400/30">
                                            <h4 className="text-lg font-semibold text-green-300">👥 Team & Assignment</h4>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">👤 Assigned To</label>
                                                <input
                                                    type="text"
                                                    placeholder="john.doe@company.com"
                                                    value={newTodoAssignedTo}
                                                    onChange={(e) => setNewTodoAssignedTo(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-green-400 focus:outline-none transition-all hover:bg-white/15"
                                                />
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🏢 Department</label>
                                                <select
                                                    value={newTodoDepartment}
                                                    onChange={(e) => setNewTodoDepartment(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-green-400 focus:outline-none transition-all hover:bg-white/15"
                                                >
                                                    {departments.map(dept => (
                                                        <option key={dept.id} value={dept.id} className="bg-gray-800">{dept.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🎯 Link</label>
                                                <input
                                                    type="text"
                                                    placeholder="LINK-2024-001"
                                                    value={newTodoEpicLink}
                                                    onChange={(e) => setNewTodoEpicLink(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-green-400 focus:outline-none transition-all hover:bg-white/15"
                                                />
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🔗 Dependencies</label>
                                                <textarea
                                                    placeholder="List blocking tasks or dependencies..."
                                                    value={newTodoDependencies}
                                                    onChange={(e) => setNewTodoDependencies(e.target.value)}
                                                    rows="3"
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-green-400 focus:outline-none transition-all hover:bg-white/15 resize-none"
                                                />
                                            </div>
                                        </div>

                                        {/* Technical & Quality Section */}
                                        <div className="space-y-4 p-4 bg-purple-900/20 rounded-lg border border-purple-400/30">
                                            <h4 className="text-lg font-semibold text-purple-300">🔧 Technical & Quality</h4>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🧩 Complexity</label>
                                                <select
                                                    value={newTodoComplexity}
                                                    onChange={(e) => setNewTodoComplexity(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-purple-400 focus:outline-none transition-all hover:bg-white/15"
                                                >
                                                    {complexities.map(comp => (
                                                        <option key={comp.id} value={comp.id} className="bg-gray-800">{comp.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">⚠️ Severity</label>
                                                <select
                                                    value={newTodoSeverity}
                                                    onChange={(e) => setNewTodoSeverity(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-purple-400 focus:outline-none transition-all hover:bg-white/15"
                                                >
                                                    {severities.map(sev => (
                                                        <option key={sev.id} value={sev.id} className="bg-gray-800">{sev.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🌍 Environment</label>
                                                <select
                                                    value={newTodoEnvironment}
                                                    onChange={(e) => setNewTodoEnvironment(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-purple-400 focus:outline-none transition-all hover:bg-white/15"
                                                >
                                                    {environments.map(env => (
                                                        <option key={env.id} value={env.id} className="bg-gray-800">{env.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🎯 Task Type</label>
                                                <select
                                                    value={newTodoTaskType}
                                                    onChange={(e) => setNewTodoTaskType(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-purple-400 focus:outline-none transition-all hover:bg-white/15"
                                                >
                                                    {taskTypes.map(type => (
                                                        <option key={type.id} value={type.id} className="bg-gray-800">{type.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* Business & Impact Section */}
                                        <div className="space-y-4 p-4 bg-red-900/20 rounded-lg border border-red-400/30">
                                            <h4 className="text-lg font-semibold text-red-300">💼 Business & Impact</h4>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">💥 Impact Level</label>
                                                <select
                                                    value={newTodoImpactLevel}
                                                    onChange={(e) => setNewTodoImpactLevel(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-red-400 focus:outline-none transition-all hover:bg-white/15"
                                                >
                                                    {impactLevels.map(impact => (
                                                        <option key={impact.id} value={impact.id} className="bg-gray-800">{impact.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">⚡ Effort Level</label>
                                                <select
                                                    value={newTodoEffortLevel}
                                                    onChange={(e) => setNewTodoEffortLevel(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-red-400 focus:outline-none transition-all hover:bg-white/15"
                                                >
                                                    {effortLevels.map(effort => (
                                                        <option key={effort.id} value={effort.id} className="bg-gray-800">{effort.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">💰 Business Value</label>
                                                <textarea
                                                    placeholder="Describe business value and justification..."
                                                    value={newTodoBusinessValue}
                                                    onChange={(e) => setNewTodoBusinessValue(e.target.value)}
                                                    rows="3"
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-red-400 focus:outline-none transition-all hover:bg-white/15 resize-none"
                                                />
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">✅ Acceptance Criteria</label>
                                                <textarea
                                                    placeholder="Define clear acceptance criteria..."
                                                    value={newTodoAcceptanceCriteria}
                                                    onChange={(e) => setNewTodoAcceptanceCriteria(e.target.value)}
                                                    rows="3"
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-red-400 focus:outline-none transition-all hover:bg-white/15 resize-none"
                                                />
                                            </div>
                                        </div>

                                        {/* Advanced Tracking Section */}
                                        <div className="space-y-4 p-4 bg-yellow-900/20 rounded-lg border border-yellow-400/30">
                                            <h4 className="text-lg font-semibold text-yellow-300">📈 Advanced Tracking</h4>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🏷️ Labels/Tags</label>
                                                <input
                                                    type="text"
                                                    placeholder="frontend, api, urgent, hotfix"
                                                    value={newTodoLabels}
                                                    onChange={(e) => setNewTodoLabels(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-yellow-400 focus:outline-none transition-all hover:bg-white/15"
                                                />
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🔗 External Links</label>
                                                <textarea
                                                    placeholder="JIRA: ABC-123&#10;Confluence: https://...&#10;GitHub PR: #456"
                                                    value={newTodoExternalLinks}
                                                    onChange={(e) => setNewTodoExternalLinks(e.target.value)}
                                                    rows="3"
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-yellow-400 focus:outline-none transition-all hover:bg-white/15 resize-none"
                                                />
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">📊 Progress %</label>
                                                <input
                                                    type="range"
                                                    min="0"
                                                    max="100"
                                                    value={newTodoProgress}
                                                    onChange={(e) => setNewTodoProgress(e.target.value)}
                                                    className="w-full h-2 bg-white/20 rounded-lg appearance-none cursor-pointer slider"
                                                />
                                                <div className="text-center text-yellow-300 font-semibold mt-1">{newTodoProgress}%</div>
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">⚡ Performance Impact</label>
                                                <textarea
                                                    placeholder="Describe performance implications..."
                                                    value={newTodoPerformanceImpact}
                                                    onChange={(e) => setNewTodoPerformanceImpact(e.target.value)}
                                                    rows="2"
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-yellow-400 focus:outline-none transition-all hover:bg-white/15 resize-none"
                                                />
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">📡 Monitoring Needs</label>
                                                <textarea
                                                    placeholder="Monitoring and alerting requirements..."
                                                    value={newTodoMonitoringNeeds}
                                                    onChange={(e) => setNewTodoMonitoringNeeds(e.target.value)}
                                                    rows="2"
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-yellow-400 focus:outline-none transition-all hover:bg-white/15 resize-none"
                                                />
                                            </div>
                                        </div>

                                        {/* Risk & Security Section */}
                                        <div className="space-y-4 p-4 bg-indigo-900/20 rounded-lg border border-indigo-400/30">
                                            <h4 className="text-lg font-semibold text-indigo-300">🛡️ Risk & Security</h4>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">⚠️ Risk Assessment</label>
                                                <select
                                                    value={newTodoRiskLevel}
                                                    onChange={(e) => setNewTodoRiskLevel(e.target.value)}
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white focus:border-indigo-400 focus:outline-none transition-all hover:bg-white/15"
                                                >
                                                    <option value="low" className="bg-gray-800">🟢 Low Risk</option>
                                                    <option value="medium" className="bg-gray-800">🟡 Medium Risk</option>
                                                    <option value="high" className="bg-gray-800">🟠 High Risk</option>
                                                    <option value="critical" className="bg-gray-800">🔴 Critical Risk</option>
                                                </select>
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🔒 Security Considerations</label>
                                                <textarea
                                                    placeholder="Security implications and requirements..."
                                                    value={newTodoSecurityNotes}
                                                    onChange={(e) => setNewTodoSecurityNotes(e.target.value)}
                                                    rows="3"
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-indigo-400 focus:outline-none transition-all hover:bg-white/15 resize-none"
                                                />
                                            </div>
                                            
                                            <div>
                                                <label className="block text-sm font-medium text-gray-300 mb-2">🧪 Testing Strategy</label>
                                                <textarea
                                                    placeholder="Testing approach and requirements..."
                                                    value={newTodoTestingStrategy}
                                                    onChange={(e) => setNewTodoTestingStrategy(e.target.value)}
                                                    rows="3"
                                                    className="w-full bg-white/10 border border-white/20 rounded-lg px-4 py-2 text-white placeholder-gray-400 focus:border-indigo-400 focus:outline-none transition-all hover:bg-white/15 resize-none"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="flex justify-end space-x-6 mt-10 pt-6 border-t border-white/10">
                                <button
                                    onClick={() => {
                                        setShowAddForm(false);
                                        setEditingTodo(null);
                                        setNewTodo('');
                                        setNewTodoDescription('');
                                        setNewTodoPriority('medium');
                                        setNewTodoCategory('feature');
                                    }}
                                    className="group relative px-8 py-4 bg-slate-700/80 hover:bg-slate-600/80 text-white rounded-xl font-medium transition-all duration-300 hover:scale-105 shadow-lg backdrop-blur-sm border border-white/10"
                                >
                                    <div className="absolute inset-0 bg-gradient-to-r from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl"></div>
                                    <div className="relative flex items-center">
                                        <i className="fas fa-times mr-2"></i>
                                        <span>Cancel</span>
                                    </div>
                                </button>
                                <button
                                    onClick={() => handleAddTodo()}
                                    disabled={isAdding || !newTodo.trim()}
                                    className="group relative px-10 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white rounded-xl font-semibold transition-all duration-300 hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed shadow-xl hover:shadow-2xl backdrop-blur-sm"
                                >
                                    <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl"></div>
                                    <div className="relative flex items-center">
                                        {isAdding ? (
                                            <>
                                                <i className="fas fa-spinner fa-spin mr-3"></i>
                                                <span>Creating Todo...</span>
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-rocket mr-3"></i>
                                                <span>✨ Create Todo</span>
                                            </>
                                        )}
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 🎯🌟💫 ULTRA MEGA TODOS LIST WITH INFINITE NESTING 🎯🌟💫 */}
            <div className="relative z-10 space-y-4">
                {filteredTodos.filter(todo => !todo.parentId).length === 0 ? (
                    <div className="glass-card rounded-2xl p-12 text-center animate-pulse">
                        <div className="w-24 h-24 bg-gray-600/30 rounded-full flex items-center justify-center mx-auto mb-6 animate-pulse">
                            <i className="fas fa-tasks text-4xl text-gray-400"></i>
                        </div>
                        <h3 className="text-2xl font-bold text-gray-400 mb-4">🎯 No Todos Found</h3>
                        <p className="text-gray-500 mb-6">Get started by adding your first todo task with infinite nesting!</p>
                        <button
                            onClick={() => setShowAddForm(true)}
                            className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:scale-110 hover:-translate-y-2 shadow-xl"
                        >
                            <i className="fas fa-rocket mr-2"></i>
                            🚀 Add Your First Todo
                        </button>
                    </div>
                ) : (
                    // 🌟💫 RENDER TOP-LEVEL TODOS WITH RECURSIVE SUBTASKS 🌟💫
                    filteredTodos
                        .filter(todo => !todo.parentId) // Only show top-level todos
                        .map(todo => renderTodoWithSubtasks(todo, 0))
                )}
            </div>
        </div>
    );
};

// ✨ SLEEK MODERN PROFESSIONAL ANIMATIONS ✨
const modernAnimationStyles = `
/* ✨ OPTIMIZED PERFORMANCE ANIMATIONS ✨ */
@keyframes elegantFloat {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-2px); }
}

@keyframes professionalGlow {
    0%, 100% { opacity: 0.8; }
    50% { opacity: 1; }
}

@keyframes subtlePulse {
    0%, 100% { opacity: 0.9; }
    50% { opacity: 1; }
}

@keyframes smoothSlideIn {
    0% { transform: translateY(20px); opacity: 0; }
    100% { transform: translateY(0); opacity: 1; }
}

@keyframes modernRotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@keyframes elegantBreathe {
    0%, 100% { opacity: 0.8; }
    50% { opacity: 1; }
}

@keyframes professionalShimmer {
    0% { 
        background-position: -200px 0; 
    }
    100% { 
        background-position: 200px 0; 
    }
}

@keyframes modernHover {
    0% { transform: translateY(0px) scale(1); }
    100% { transform: translateY(-5px) scale(1.02); }
}

@keyframes advancedGlow {
    0% { 
        box-shadow: 0 0 20px rgba(59, 130, 246, 0.2), 0 4px 20px rgba(0, 0, 0, 0.1); 
        filter: brightness(1);
    }
    25% { 
        box-shadow: 0 0 35px rgba(59, 130, 246, 0.4), 0 8px 30px rgba(0, 0, 0, 0.15); 
        filter: brightness(1.1);
    }
    50% { 
        box-shadow: 0 0 50px rgba(99, 102, 241, 0.5), 0 12px 40px rgba(0, 0, 0, 0.2); 
        filter: brightness(1.15);
    }
    75% { 
        box-shadow: 0 0 35px rgba(139, 92, 246, 0.4), 0 8px 30px rgba(0, 0, 0, 0.15); 
        filter: brightness(1.1);
    }
    100% { 
        box-shadow: 0 0 20px rgba(59, 130, 246, 0.2), 0 4px 20px rgba(0, 0, 0, 0.1); 
        filter: brightness(1);
    }
}

@keyframes hoverLift {
    0% { 
        transform: translateY(0) scale(1) rotateX(0deg); 
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }
    50% { 
        transform: translateY(-4px) scale(1.015) rotateX(2deg); 
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    }
    100% { 
        transform: translateY(-8px) scale(1.03) rotateX(5deg); 
        box-shadow: 0 16px 32px rgba(0, 0, 0, 0.2);
    }
}

@keyframes enhancedShimmer {
    0% { 
        background-position: -200% 0;
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% { 
        background-position: 200% 0;
        opacity: 0;
    }
}

/* 🚀 ULTRA MODERN SLEEK ANIMATIONS 🚀 */
@keyframes modernPulse {
    0% { 
        transform: scale(1); 
        opacity: 0.6;
    }
    50% { 
        transform: scale(1.02); 
        opacity: 1;
    }
    100% { 
        transform: scale(1); 
        opacity: 0.6;
    }
}

@keyframes borderFlow {
    0% { 
        background-position: 0% 50%;
        opacity: 0.3;
    }
    50% { 
        background-position: 100% 50%;
        opacity: 1;
    }
    100% { 
        background-position: 200% 50%;
        opacity: 0.3;
    }
}

@keyframes elegantShimmer {
    0% { 
        transform: translateX(-100%) rotateZ(10deg);
        opacity: 0;
    }
    50% { 
        opacity: 1;
    }
    100% { 
        transform: translateX(200%) rotateZ(10deg);
        opacity: 0;
    }
}

@keyframes subtleGlow {
    0% { 
        box-shadow: 0 0 20px rgba(59, 130, 246, 0.1);
    }
    50% { 
        box-shadow: 0 0 40px rgba(59, 130, 246, 0.3);
    }
    100% { 
        box-shadow: 0 0 20px rgba(59, 130, 246, 0.1);
    }
}

@keyframes titleGlow {
    0% { 
        transform: scale(1);
        filter: brightness(1) saturate(1);
    }
    50% { 
        transform: scale(1.02);
        filter: brightness(1.1) saturate(1.2);
    }
    100% { 
        transform: scale(1);
        filter: brightness(1) saturate(1);
    }
}

@keyframes textFloat {
    0% { 
        transform: translateY(0px);
    }
    25% { 
        transform: translateY(-2px);
    }
    75% { 
        transform: translateY(1px);
    }
    100% { 
        transform: translateY(0px);
    }
}

@keyframes flowingLight {
    0% { 
        transform: translateX(-100%);
    }
    100% { 
        transform: translateX(300%);
    }
}

@keyframes float {
    0% { 
        transform: translateY(0px) scale(1);
    }
    50% { 
        transform: translateY(-6px) scale(1.1);
    }
    100% { 
        transform: translateY(0px) scale(1);
    }
}

@keyframes statsGlow {
    0% { 
        transform: scale(1);
        filter: hue-rotate(0deg);
    }
    50% { 
        transform: scale(1.05);
        filter: hue-rotate(90deg);
    }
    100% { 
        transform: scale(1);
        filter: hue-rotate(0deg);
    }
}

@keyframes iconFloat {
    0% { 
        transform: translateY(0px) rotateY(0deg);
    }
    50% { 
        transform: translateY(-3px) rotateY(180deg);
    }
    100% { 
        transform: translateY(0px) rotateY(360deg);
    }
}

@keyframes textGlow {
    0% { 
        text-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
    }
    50% { 
        text-shadow: 0 0 20px rgba(255, 255, 255, 0.4), 0 0 30px rgba(59, 130, 246, 0.3);
    }
    100% { 
        text-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
    }
}

@keyframes buttonGlow {
    0% { 
        transform: scale(1);
        filter: brightness(1) hue-rotate(0deg);
    }
    25% { 
        transform: scale(1.02);
        filter: brightness(1.1) hue-rotate(45deg);
    }
    50% { 
        transform: scale(1.05);
        filter: brightness(1.2) hue-rotate(90deg);
    }
    75% { 
        transform: scale(1.02);
        filter: brightness(1.1) hue-rotate(135deg);
    }
    100% { 
        transform: scale(1);
        filter: brightness(1) hue-rotate(180deg);
    }
}

@keyframes particleFloat {
    0% { 
        transform: translateY(0px) scale(0) rotate(0deg);
        opacity: 0;
    }
    25% { 
        transform: translateY(-10px) scale(1) rotate(90deg);
        opacity: 1;
    }
    75% { 
        transform: translateY(-15px) scale(1.2) rotate(270deg);
        opacity: 0.8;
    }
    100% { 
        transform: translateY(-20px) scale(0) rotate(360deg);
        opacity: 0;
    }
}

@keyframes iconPulse {
    0% { 
        transform: scale(1) rotate(0deg);
        filter: brightness(1);
    }
    50% { 
        transform: scale(1.1) rotate(180deg);
        filter: brightness(1.3);
    }
    100% { 
        transform: scale(1) rotate(360deg);
        filter: brightness(1);
    }
}

@keyframes iconSpin {
    0% { 
        transform: rotate(0deg) scale(1);
    }
    100% { 
        transform: rotate(720deg) scale(1.2);
    }
}

@keyframes dotPulse {
    0% { 
        transform: scale(1);
        opacity: 0.6;
    }
    50% { 
        transform: scale(1.5);
        opacity: 1;
    }
    100% { 
        transform: scale(1);
        opacity: 0.6;
    }
}

@keyframes dotSpin {
    0% { 
        transform: scale(1) rotate(0deg);
        opacity: 0.6;
    }
    50% { 
        transform: scale(1.8) rotate(180deg);
        opacity: 1;
    }
    100% { 
        transform: scale(1) rotate(360deg);
        opacity: 0.6;
    }
}

/* ✨ ENHANCED MODERN HOVER EFFECTS ✨ */
.hover-modern:hover {
    transform: translateY(-8px) scale(1.03) !important;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
    filter: brightness(1.15) contrast(1.05) !important;
    box-shadow: 
        0 20px 40px rgba(0, 0, 0, 0.2), 
        0 0 40px rgba(59, 130, 246, 0.4),
        0 0 80px rgba(99, 102, 241, 0.2) !important;
    animation: professionalGlow 1.5s ease-in-out infinite !important;
}

.hover-elegant:hover {
    transform: translateY(-6px) scale(1.02) rotateX(5deg) !important;
    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
    box-shadow: 
        0 15px 30px rgba(0, 0, 0, 0.15), 
        0 0 30px rgba(99, 102, 241, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
    animation: elegantFloat 2s ease-in-out infinite, professionalShimmer 2s ease-in-out infinite !important;
    backdrop-filter: blur(25px) saturate(150%) !important;
}

.hover-professional:hover {
    animation: professionalGlow 1.2s ease-in-out infinite, subtlePulse 2s ease-in-out infinite !important;
    transform: translateY(-4px) scale(1.015) !important;
    filter: brightness(1.1) saturate(1.1) !important;
    box-shadow: 
        0 12px 25px rgba(0, 0, 0, 0.12),
        0 0 25px rgba(59, 130, 246, 0.25) !important;
    border-color: rgba(99, 102, 241, 0.4) !important;
}

.hover-sleek:hover {
    animation: elegantBreathe 1.5s ease-in-out infinite, modernRotate 8s linear infinite !important;
    transform: scale(1.025) translateZ(10px) !important;
    filter: brightness(1.12) contrast(1.08) saturate(1.05) !important;
    transition: all 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
    box-shadow: 
        0 10px 20px rgba(0, 0, 0, 0.1),
        0 0 20px rgba(59, 130, 246, 0.2) !important;
}

.hover-enhanced:hover {
    transform: translateY(-10px) scale(1.04) rotateY(2deg) !important;
    transition: all 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55) !important;
    filter: brightness(1.2) contrast(1.1) saturate(1.15) !important;
    box-shadow: 
        0 25px 50px rgba(0, 0, 0, 0.25), 
        0 0 50px rgba(59, 130, 246, 0.5),
        0 0 100px rgba(99, 102, 241, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.15) !important;
    animation: elegantFloat 1.8s ease-in-out infinite, professionalGlow 1s ease-in-out infinite !important;
}

/* ✨ ENHANCED GLASS MORPHISM DESIGN ✨ */
.glass-card-modern {
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border: 1px solid rgba(255, 255, 255, 0.15);
    animation: elegantBreathe 4s ease-in-out infinite;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.glass-card-modern:hover {
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(30px) saturate(220%);
    -webkit-backdrop-filter: blur(30px) saturate(220%);
    border: 1px solid rgba(59, 130, 246, 0.4);
    animation: advancedGlow 2s ease-in-out infinite;
    transform: translateY(-3px) scale(1.015);
    box-shadow: 
        0 15px 35px rgba(0, 0, 0, 0.18), 
        0 0 40px rgba(59, 130, 246, 0.25),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.glass-card-modern::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.15), transparent);
    animation: enhancedShimmer 3s ease-in-out infinite;
    pointer-events: none;
    z-index: 1;
}

.glass-card-professional {
    background: rgba(15, 23, 42, 0.7);
    backdrop-filter: blur(15px) saturate(150%);
    -webkit-backdrop-filter: blur(15px) saturate(150%);
    border: 1px solid rgba(59, 130, 246, 0.2);
    animation: subtlePulse 3s ease-in-out infinite;
    position: relative;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.glass-card-professional:hover {
    background: rgba(15, 23, 42, 0.8);
    animation: hoverLift 0.6s ease-out forwards, advancedGlow 1.5s ease-in-out infinite;
    backdrop-filter: blur(25px) saturate(200%);
    -webkit-backdrop-filter: blur(25px) saturate(200%);
    border-color: rgba(99, 102, 241, 0.5);
    box-shadow: 
        0 20px 40px rgba(0, 0, 0, 0.25),
        0 0 50px rgba(59, 130, 246, 0.4),
        0 0 100px rgba(99, 102, 241, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.glass-card-professional::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(99, 102, 241, 0.1), transparent);
    animation: enhancedShimmer 4s ease-in-out infinite;
    pointer-events: none;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.glass-card-professional:hover::after {
    opacity: 1;
    animation: enhancedShimmer 2s ease-in-out infinite;
}

/* ✨ ENHANCED MODERN UTILITY CLASSES ✨ */
.animate-elegantFloat {
    animation: elegantFloat 3s ease-in-out infinite;
}

.animate-professionalGlow {
    animation: professionalGlow 2s ease-in-out infinite;
}

.animate-advancedGlow {
    animation: advancedGlow 2s ease-in-out infinite;
}

.animate-subtlePulse {
    animation: subtlePulse 2.5s ease-in-out infinite;
}

.animate-smoothSlideIn {
    animation: smoothSlideIn 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.animate-modernRotate {
    animation: modernRotate 8s linear infinite;
}

.animate-elegantBreathe {
    animation: elegantBreathe 3s ease-in-out infinite;
}

.animate-professionalShimmer {
    animation: professionalShimmer 2s ease-in-out infinite;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    background-size: 200px 100%;
}

.animate-enhancedShimmer {
    animation: enhancedShimmer 3s ease-in-out infinite;
    background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.2), transparent);
    background-size: 200px 100%;
}

.animate-modernHover {
    animation: modernHover 0.3s ease-out;
}

.animate-hoverLift {
    animation: hoverLift 0.6s ease-out forwards;
}

/* Optimized scrollbar */
::-webkit-scrollbar {
    width: 8px;
}

::-webkit-scrollbar-track {
    background: rgba(15, 23, 42, 0.3);
    border-radius: 4px;
}

::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, rgba(59, 130, 246, 0.8), rgba(99, 102, 241, 0.8));
    border-radius: 4px;
    transition: all 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, rgba(59, 130, 246, 1), rgba(99, 102, 241, 1));
}

/* Sleek modal and form styles */
.glass-card-sleek {
    background: rgba(15, 23, 42, 0.8);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.glass-card-sleek:hover {
    background: rgba(15, 23, 42, 0.9);
    border-color: rgba(59, 130, 246, 0.3);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

@keyframes gentle-shimmer {
    0% { transform: translateX(-100%); opacity: 0; }
    50% { opacity: 0.6; }
    100% { transform: translateX(200%); opacity: 0; }
}

.animate-gentle-shimmer {
    animation: gentle-shimmer 3s ease-in-out infinite;
}

/* Disabled particle effects for better performance */
`;

// Inject styles into document head
if (typeof document !== 'undefined') {
    const existingStyles = document.getElementById('modern-todo-animations');
    if (!existingStyles) {
        const styleSheet = document.createElement('style');
        styleSheet.id = 'modern-todo-animations';
        styleSheet.textContent = modernAnimationStyles;
        document.head.appendChild(styleSheet);
    }
}

export default TodoPage;
